/*
 * JANGIN — product split-view height sync.
 * On desktop (>=990px), the left media column's max-height is
 * pinned to the right info column's natural content height so
 * the two columns end at the same Y. The left column scrolls
 * internally (overflow-y: auto) when the cursor is over it;
 * cursor elsewhere scrolls the page natively.
 */
(function () {
  const BREAKPOINT = 990;

  function init(productInfo) {
    const info = productInfo.querySelector('.product__info-wrapper');
    const media = productInfo.querySelector('.product__media-wrapper');
    if (!info || !media) return;

    const sync = () => {
      if (window.innerWidth >= BREAKPOINT) {
        media.style.maxHeight = `${info.offsetHeight}px`;
        media.style.overflowY = 'auto';
      } else {
        media.style.maxHeight = '';
        media.style.overflowY = '';
      }
    };

    const ro = new ResizeObserver(sync);
    ro.observe(info);
    window.addEventListener('resize', sync);
    sync();
  }

  function start() {
    document.querySelectorAll('product-info').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
